import { createAction, props } from '@ngrx/store';
import { Value } from '../../../domain/value.interface';

export const loadValuesList = createAction(
  '[VALUE] Load Values List',
  props<{ formId: string, versionId: string }>()
);

export const loadValuesListSuccess = createAction(
  '[VALUE] Load Values List Success',
  props<{ data: any }>()
);

export const loadValuesListFailure = createAction(
  '[VALUE] Load Values List Failure',
  props<{ error: any }>()
);

export const getSelectedValue = createAction(
  '[VALUE] Get Selected Value',
  props<{ formId: string, versionId: string, value: Value }>()
);

export const getSelectedValueSuccess = createAction(
  '[VALUE] Get Selected Value Success',
  props<{ value: Value }>()
);

export const getSelectedValueFailure = createAction(
  '[VALUE] Get Selected Value Failure',
  props<{ error: string }>()
);